import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/index.jsx';
import { categoryName } from '../../format.js';
import { flag, formatQty, destination, timeframeText, shortDate } from './requestUtils.js';

// A buying request on the marketplace: "ACHÈTE / WANTED" badge (amber —
// product cards have none), what, how much, where, when, until when, offers.
export default function RequestCard({ request: r, to, extra }) {
  const { t, lang } = useI18n();
  const dest = destination(r, lang);
  const when = timeframeText(r, lang);
  return (
    <Link to={to || `/marketplace/requests/${r.id}`} className={`req-card${r.open ? '' : ' is-closed'}`}>
      <div className="req-card-top">
        <span className="wanted-badge">{t('buying.wanted')}</span>
        {!r.open && <span className={`chip-status req-status-${r.status}`}>{t(`buying.status.${r.status}`)}</span>}
        {r.featured && <span className="featured-badge">★</span>}
      </div>
      <p className="listing-card-cat">{categoryName(r.category, lang)}</p>
      <h3 className="req-card-title">{r.title}</h3>
      <dl className="req-card-facts">
        <div><dt>{t('buying.quantity')}</dt><dd><strong>{formatQty(r.quantity, r.unit, lang, t)}</strong></dd></div>
        {dest && <div><dt>{t('buying.destination')}</dt><dd>{r.destCountry && <span className="req-flag" aria-hidden="true">{flag(r.destCountry)} </span>}{dest}{r.incoterm ? ` · ${r.incoterm}` : ''}</dd></div>}
        {when && <div><dt>{t('buying.timeframe')}</dt><dd>{when}</dd></div>}
      </dl>
      <div className="req-card-foot">
        <span>{r.offers ? t('buying.offersN', { n: r.offers }) : t('buying.noOffers')}</span>
        <span className="muted">{t(r.open ? 'buying.expires' : 'buying.expired', { date: shortDate(r.expiresOn, lang) })}</span>
      </div>
      {extra}
    </Link>
  );
}
